export const translations = {
  EN: {
    hero: {
      title: "Welcome to SocratesLab",
      tagline: "Revolutionizing Education Through AI-Powered Learning",
      getStarted: "Get Started",
      tryDemo: "Try Demo",
      pilotTesting: "Currently pilot testing with leading institutions",
    },
    nav: {
      why: "WHY SOCRATESLAB?",
      products: "PRODUCTS",
      company: "COMPANY",
      about: "ABOUT",
      demo: "I WANT A DEMO",
      features: {
        aiLearning: "AI-Powered Learning",
        interactiveModules: "Interactive Modules",
        feedback: "Feedback & Scaffolding",
        management: "Advanced Management",
      },
      menu: {
        aiLearning: "AI-Powered Learning",
        interactiveModules: "Interactive Modules",
        feedbackScaffolding: "Feedback & Scaffolding",
        advancedManagement: "Advanced Management",
      },
    },
    contact: {
      title: "Get in touch",
      description:
        "Ready to transform your educational experience? Contact us today!",
      info: "Contact Information",
      form: {
        name: "Your Name",
        email: "Your Email",
        message: "Your Message",
        submit: "Send Message",
        success: "Message sent successfully!",
        error: "Error sending message. Please try again.",
        required: "This field is required",
        invalidEmail: "Please enter a valid email",
        sending: "Sending message...",
      },
      address: {
        street: "260 rue France",
        city: "Saint-Philippe",
        state: "Quebec",
        country: "Canada",
        postal: "J0L 2K0",
        phone: "514-792-7385",
      },
    },
    footer: {
      legal: "Legal",
      terms: "Terms of Use",
      privacy: "Privacy Policy",
      cookies: "Cookie Policy",
      gdpr: "GDPR",
      california: "California Notice",
    },
    aiLearning: {
      title: "AI-Powered Learning Experience",
      description:
        "Experience the future of education with our cutting-edge AI technology that transforms how students learn and teachers teach.",
      features: {
        personalizedFeedback: {
          title: "Personalized AI Feedback",
          description:
            "AI algorithms help students receive personalized feedback on their mistakes, creating customized educational journeys.",
        },
        analytics: {
          title: "AI Classroom Analytics",
          description:
            "Real-time analysis of learning performance with AI-powered classroom analytics help teachers identify skills requiring improvement.",
        },
        language: {
          title: "Language Processing",
          description:
            "Advanced NLP capabilities for enhanced language learning and comprehension on oral practice and exams.",
        },
        content: {
          title: "Smart Content Generation",
          description:
            "AI-powered content creation makes it a breeze to deliver engaging courses tailored to specific learning objectives.",
        },
        progress: {
          title: "Smart Progress Tracking",
          description:
            "AI-powered progress tracking and specialized learning plans for each student or class.",
        },
        tutors: {
          title: "Engaging AI Tutors",
          description:
            "AI-powered tutors that engage students in learning and encourage them to talk with Socratic questioning.",
        },
      },
    },
    feedback: {
      title: "Feedback & Scaffolding",
      description:
        "Our intelligent feedback system provides the right support at the right time, helping students build confidence and achieve their learning goals.",
      features: {
        immediate: {
          title: "Immediate Feedback",
          description:
            "System-generated feedback that detects mistakes and provides immediate feedback.",
        },
        generative: {
          title: "Generative AI Feedback",
          description:
            "Save up to 60% of grading time with AI-powered personalized feedback. Our advanced AI analyzes responses across diverse formats—text, audio, and more—providing students with detailed explanations and strategies for improvement. The result? Consistent, scalable, and objective feedback tailored to your classroom’s unique needs.",
        },
        custom: {
          title: "Customized Teacher Feedback",
          description:
            "A comprehensive coaching approach where teachers combine their expertise with AI feedback to create a complete learning experience. Teachers can provide contextual comments, highlight specific strengths, and suggest targeted improvement strategies based on their deep understanding of each student's journey.",
        },
        adaptive: {
          title: "Adaptive Scaffolding",
          description:
            "Time-labelled audio comments, question-based instructions, activity-based how-to buttons, and more.",
        },
        rubrics: {
          title: "Integrated Rubrics",
          description:
            "Transparent assessment framework with clear scoring criteria transforms evaluation into a learning opportunity. Students can see exactly what excellence looks like at each level, while teachers can ensure consistent, fair grading across assignments. Using rubrics has been shown to improve student performance by up to 30%",
        },
        tips: {
          title: "Adaptive Question Tips",
          description:
            "Smart hints that remain hidden until students choose to reveal them - empowering learners to tackle challenges at their own level. Those who feel confident can proceed without tips, while others can access targeted support exactly when they need it, creating a naturally adaptive learning experience.",
        },
      },
    },
    features: {
      title: "Why Choose SocratesLab?",
      description:
        "Socrates is an innovative teaching and learning management platform that has a wide set of tools specifically designed for educational institutions.",
      items: {
        ai: {
          title: "AI-Powered Learning",
          description:
            "Personalized learning experiences powered by advanced AI at every level.",
        },
        interactive: {
          title: "Interactive Modules",
          description:
            "Dynamic content through our interactive learning modules.",
        },
        feedback: {
          title: "Corrective Feedback and Scaffolding",
          description:
            "Right feedback at the right time. Adaptive scaffolding, tips, integrated rubrics and more.",
        },
        management: {
          title: "Advanced Course Management",
          description:
            "Smart courses, interactive content, and flexible student accommodations.",
        },
      },
    },
    interactive: {
      title: "Interactive Learning Modules",
      description:
        "Engage with our comprehensive suite of interactive learning tools designed to make language education more effective and enjoyable.",
      features: {
        exercises: {
          title: "Interactive Exercises",
          description:
            "Engage with dynamic exercises that offer learning tools to help students practice.",
        },
        video: {
          title: "Video Learning",
          description:
            "High-quality video content with interactive elements and follow-up questions.",
        },
        audio: {
          title: "Audio Learning",
          description:
            "Advanced audio recording capabilities and noise supression, so users can even practice in crowded rooms or noisy environments.",
        },
        gamified: {
          title: "Gamified Learning",
          description:
            "Educational games and challenges that make learning engaging and fun.",
        },
      },
    },
    management: {
      title: "Advanced Course Management",
      description:
        "Take control of your educational content with our comprehensive course management tools designed for modern educators.",
      features: {
        structure: {
          title: "Flexible Course Structure",
          description:
            "Create and organize course content with customizable sections, modes, and learning paths.",
        },
        content: {
          title: "Dynamic Content Control",
          description:
            "Show or hide content sections, set availability dates and timers, and manage special access permissions.",
        },
        progress: {
          title: "Progress Monitoring",
          description:
            "Track student engagement, completion rates, and performance metrics in real-time.",
        },
      },
    },
    demo: {
      title: "Try it yourself!",
      tryAgain: "Try Again",
      correct: "Correct order!",
      incorrect: "Incorrect order. Try again!",
      sentence: "It has never been so much fun to [spell] words!",
    },
  },
  FR: {
    hero: {
      title: "Bienvenue à SocratesLab",
      tagline:
        "Révolutionner l'éducation grâce à l'apprentissage alimenté par l'IA",
      getStarted: "Commencer",
      tryDemo: "Essayer la démo",
      pilotTesting:
        "Actuellement en phase de test pilote avec des institutions de premier plan",
    },
    nav: {
      why: "POURQUOI SOCRATESLAB?",
      products: "PRODUITS",
      company: "ENTREPRISE",
      about: "À PROPOS",
      demo: "JE VEUX UNE DÉMO",
      features: {
        aiLearning: "Apprentissage par IA",
        interactiveModules: "Modules Interactifs",
        feedback: "Rétroaction et Échafaudage",
        management: "Gestion Avancée",
      },
      menu: {
        aiLearning: "Apprentissage par IA",
        interactiveModules: "Modules Interactifs",
        feedbackScaffolding: "Rétroaction et Échafaudage",
        advancedManagement: "Gestion Avancée",
      },
    },
    contact: {
      title: "Contactez-nous",
      description:
        "Prêt à transformer votre expérience éducative ? Contactez-nous dès aujourd'hui !",
      info: "Informations de Contact",
      form: {
        name: "Votre Nom",
        email: "Votre Email",
        message: "Votre Message",
        submit: "Envoyer le Message",
        success: "Message envoyé avec succès !",
        error: "Erreur lors de l'envoi du message. Veuillez réessayer.",
        required: "Ce champ est obligatoire",
        invalidEmail: "Veuillez entrer un email valide",
        sending: "Envoi du message...",
      },
      address: {
        street: "260 rue France",
        city: "Saint-Philippe",
        state: "Québec",
        country: "Canada",
        postal: "J0L 2K0",
        phone: "514-792-7385",
      },
    },
    footer: {
      legal: "Mentions Légales",
      terms: "Conditions d'Utilisation",
      privacy: "Politique de Confidentialité",
      cookies: "Politique des Cookies",
      gdpr: "RGPD",
      california: "Avis Californie",
    },
    aiLearning: {
      title: "Expérience d'Apprentissage par IA",
      description:
        "Découvrez l'avenir de l'éducation avec notre technologie d'IA de pointe qui transforme la façon dont les élèves apprennent et les enseignants enseignent.",
      features: {
        personalizedFeedback: {
          title: "Rétroaction IA Personnalisée",
          description:
            "Les algorithmes d'IA aident les élèves à recevoir des commentaires personnalisés sur leurs erreurs, créant des parcours éducatifs sur mesure.",
        },
        analytics: {
          title: "Analytique de Classe IA",
          description:
            "Analyse en temps réel des performances d'apprentissage avec des analyses de classe alimentées par l'IA pour aider les enseignants à identifier les compétences nécessitant une amélioration.",
        },
        language: {
          title: "Traitement du Langage",
          description:
            "Capacités avancées de NLP pour améliorer l'apprentissage des langues et la compréhension lors des pratiques orales et des examens.",
        },
        content: {
          title: "Génération de Contenu Intelligent",
          description:
            "La création de matériel éducatif alimentée par l'IA facilite la création de cours engageants adaptés aux objectifs d'apprentissage spécifiques.",
        },
        progress: {
          title: "Suivi Intelligent des Progrès",
          description:
            "Suivi des progrès et plans d'apprentissage spécialisés pour chaque élève ou classe, alimentés par l'IA.",
        },
        tutors: {
          title: "Tuteurs IA Engageants",
          description:
            "Tuteurs alimentés par l'IA qui engagent les élèves dans l'apprentissage et les encouragent à parler avec un questionnement socratique.",
        },
      },
    },
    feedback: {
      title: "Rétroaction et Échafaudage",
      description:
        "Notre système de rétroaction intelligent fournit le bon soutien au bon moment, aidant les élèves à développer leur confiance et à atteindre leurs objectifs d'apprentissage.",
      features: {
        immediate: {
          title: "Rétroaction Immédiate",
          description:
            "Rétroaction générée par le système qui détecte les erreurs et fournit des commentaires immédiats.",
        },
        generative: {
          title: "Rétroaction IA Générative",
          description:
            "Économisez jusqu'à 60% du temps de correction grâce à la rétroaction personnalisée propulsée par l'IA. Notre IA avancée analyse les réponses dans divers formats — texte, audio et plus encore — offrant aux étudiants des explications détaillées et des stratégies d'amélioration. Le résultat ? Une rétroaction cohérente, évolutive et objective, adaptée aux besoins spécifiques de votre classe.",
        },
        custom: {
          title: "Rétroaction Customisée par l'Enseignant",
          description:
            "Un accompagnement complet des enseignants qui se combine avec la rétroaction IA pour créer une expérience d'apprentissage complète. Les enseignants peuvent fournir des commentaires contextuels, souligner des forces spécifiques et proposer des stratégies d'amélioration ciblées basées sur leur compréhension approfondie du parcours de chaque étudiant.",
        },
        adaptive: {
          title: "Échafaudage Adaptatif",
          description:
            "Commentaires audio horodatés, instructions basées sur des questions, boutons d'aide contextuelle, et plus encore.",
        },
        rubrics: {
          title: "Rubriques Intégrées",
          description:
            "Un cadre d'évaluation transparent avec des critères de notation clairs transforme l'évaluation en opportunité d'apprentissage. Les étudiants peuvent voir exactement à quoi ressemble l'excellence à chaque niveau, tandis que les enseignants peuvent assurer une notation cohérente et équitable. L'utilisation de rubriques a démontré une amélioration des performances des étudiants jusqu'à 30%",
        },
        tips: {
          title: "Conseils de Questions Adaptatifs",
          description:
            "Des indices intelligents qui restent cachés jusqu'à ce que les étudiants choisissent de les révéler - permettant aux apprenants de relever les défis à leur propre niveau. Ceux qui se sentent confiants peuvent avancer sans conseils, tandis que d'autres peuvent accéder à un soutien ciblé exactement quand ils en ont besoin, créant une expérience d'apprentissage naturellement adaptative.",
        },
      },
    },
    features: {
      title: "Pourquoi Choisir SocratesLab?",
      description:
        "Socrates est une plateforme innovante d'enseignement et de gestion de l'apprentissage qui dispose d'une large gamme d'outils spécialement conçus pour les établissements d'enseignement.",
      items: {
        ai: {
          title: "Apprentissage par IA",
          description:
            "Expériences d'apprentissage personnalisées alimentées par l'IA avancée à tous les niveaux.",
        },
        interactive: {
          title: "Modules Interactifs",
          description:
            "Contenu dynamique à travers nos modules d'apprentissage interactifs.",
        },
        feedback: {
          title: "Rétroaction Corrective et Échafaudage",
          description:
            "La bonne rétroaction au bon moment. Échafaudage adaptatif, conseils, rubriques intégrées et plus encore.",
        },
        management: {
          title: "Gestion Avancée des Cours",
          description:
            "Cours intelligents, contenu interactif et accommodements flexibles pour les étudiants.",
        },
      },
    },
    interactive: {
      title: "Modules d'Apprentissage Interactifs",
      description:
        "Engagez-vous avec notre suite complète d'outils d'apprentissage interactifs conçus pour rendre l'éducation linguistique plus efficace et agréable.",
      features: {
        exercises: {
          title: "Exercices Interactifs",
          description:
            "Participez à des exercices dynamiques qui offrent des outils d'apprentissage pour aider les étudiants à pratiquer.",
        },
        video: {
          title: "Apprentissage Vidéo",
          description:
            "Contenu vidéo de haute qualité avec éléments interactifs et questions de suivi.",
        },
        audio: {
          title: "Apprentissage Audio",
          description:
            "Capacités avancées d'enregistrement audio et suppression du bruit, permettant aux utilisateurs de pratiquer même dans des salles bondées ou des environnements bruyants.",
        },
        gamified: {
          title: "Apprentissage Ludique",
          description:
            "Jeux éducatifs et défis qui rendent l'apprentissage engageant et amusant.",
        },
      },
    },
    management: {
      title: "Gestion Avancée des Cours",
      description:
        "Prenez le contrôle de votre contenu éducatif avec nos outils complets de gestion de cours conçus pour les éducateurs modernes.",
      features: {
        structure: {
          title: "Structure de Cours Flexible",
          description:
            "Créez et organisez le contenu des cours avec des sections, des modes et des parcours d'apprentissage personnalisables.",
        },
        content: {
          title: "Contrôle Dynamique du Contenu",
          description:
            "Affichez ou masquez des sections de contenu, définissez des dates de disponibilité et des minuteries, et gérez les autorisations d'accès spéciales.",
        },
        progress: {
          title: "Suivi des Progrès",
          description:
            "Suivez l'engagement des étudiants, les taux d'achèvement et les mesures de performance en temps réel.",
        },
      },
    },
    demo: {
      title: "Essayez-le vous-même !",
      tryAgain: "Réessayer",
      correct: "Ordre correct !",
      incorrect: "Ordre incorrect. Réessayez !",
      sentence: "Ça n'a jamais été aussi amusant d'[épeler] des mots !",
    },
  },
};
